import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_btn_group = _resolveComponent("q-btn-group")!
  const _component_select_header = _resolveComponent("select-header")!
  const _component_client_details = _resolveComponent("client-details")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_select_header, {
      class: "catalogue-select",
      modelValue: _ctx.active,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.active) = $event)),
      options: _ctx.clients,
      "onUpdate:options": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.clients) = $event)),
      loading: _ctx.loading,
      "onUpdate:loading": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loading) = $event)),
      placeholder: _ctx.loading ? '...' : 'Select a Client',
      "create-label": "+ Client",
      "options-map": {label: 'name', value: true, subtitle: e => `${e.supplier?.id || ''}` },
      "on-create": _ctx.createClient,
      "on-update": e => _ctx.active = e,
      description: _ctx.loading ? '' : `${_ctx.clients?.length} client catalogues`,
      "data-cy": "supplier-catalogue-select-header"
    }, _createSlots({ _: 2 }, [
      (_ctx.active)
        ? {
            name: "actions",
            fn: _withCtx(() => [
              _createVNode(_component_q_btn_group, {
                class: "channel-client-btns",
                outline: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_btn, {
                    outline: "",
                    class: _normalizeClass({active: _ctx.$route.name === 'Channels'}),
                    onClick: _withModifiers(_ctx.onChannelClick, ["stop"])
                  }, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createTextVNode("Channel")
                    ])),
                    _: 1
                  }, 8, ["class", "onClick"]),
                  _createVNode(_component_q_btn, {
                    outline: "",
                    class: _normalizeClass({active: _ctx.$route.name === 'Clients'})
                  }, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createTextVNode("Client")
                    ])),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              })
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["modelValue", "options", "loading", "placeholder", "options-map", "on-create", "on-update", "description"]),
    (_ctx.active)
      ? (_openBlock(), _createBlock(_component_client_details, {
          key: 0,
          client: _ctx.active,
          "onUpdate:client": _ctx.saveClient,
          onDelete: _ctx.deleteClient
        }, null, 8, ["client", "onUpdate:client", "onDelete"]))
      : _createCommentVNode("", true)
  ], 64))
}